const getImage = filename => require(`../../assets/images/self-inspect/${filename}`);

export const QUICK_VUE_IMAGES = {
  BLUESKY: require('../../assets/images/bluesky-vue-logo.png'),
  RENOVATIONS: getImage('renovations.png'),
  ELECTRIC_PANEL: getImage('electric-panel.png'),
  WATER_HEATER: getImage('water-heater.png'),
  WOOD_STOVE: getImage('wood-stove.png'),
  LIVING_ROOM: getImage('living_room.png'),
  LIVING_ROOM_SQUARE: getImage('living_room_square.png'),
  KITCHEN: getImage('kitchen_transparent.png'),
  ADD_PHOTO: getImage('camera.png'),
  //
  EXPOSURE_OUTBUILDING: getImage('outbuilding.png'),
  EXPOSURE_TRAMPOLINE: getImage('trampoline.png'),
  EXPOSURE_POOL: getImage('pool.png'),
  //
  REAL_DOGS: getImage('dogs_real.png'),
  REAL_DOGS_SQUARE: getImage('dogs_real_square.png'),
  DOG_AKITA: getImage('dog-akita.png'),
  DOG_ALASKAN_MALAMUTE: getImage('dog-alaskan-malamute.png'),
  DOG_AMERICAN_STAFFORDSHIRE_TERRIER: getImage('dog-american-staffordshire-terrier.png'),
  DOG_BOXER: getImage('dog-boxer.png'),
  DOG_CHOW_CHOW: getImage('dog-chow-chow.png'),
  DOG_DALMATION: getImage('dog-dalmation.png'),
  DOG_DOBERMAN_PINSCHER: getImage('dog-doberman.png'),
  DOG_GERMAN_SHEPHERD: getImage('dog-german-shepherd.png'),
  DOG_HUSKY: getImage('dog-husky.png'),
  DOG_MASTIFF: getImage('dog-mastiff.png'),
  DOG_PIT_BULL: getImage('dog-pit-bull.png'),
  DOG_PRESA_CANARIO: getImage('dog-presa-canario.png'),
  DOG_ROTTWEILER: getImage('dog-rottweiler.png'),
  DOG_STAFFORDSHIRE_BULL: getImage('dog-staffordshire-bull-terrier.png'),
  DOG_DOG_WOLF_HYBRID: getImage('dog-wolf.png'),
  DOG_OTHER: getImage('dogs-other.png'),

  //
  HOUSE_FRONT: getImage('house_front.png'),
  HOUSE_FRONT_LEFT: getImage('front_corner.png'),
  HOUSE_FRONT_RIGHT: getImage('front_corner_flipped.png'),
  HOUSE_REAR_LEFT: getImage('rear_corner_flipped.png'),
  HOUSE_REAR_RIGHT: getImage('rear_corner.png'),
  HOUSE_ROOF_CLOSEUP: getImage('roof_closeup.png'),
  BACKYARD: getImage('backyard.png'),
  ADDRESS: getImage('address.png'),
  //
  PLACEHOLDER: getImage('placeholder.png'),
  //
  BARN: getImage('barn.png'),
};
